// import React, { useEffect, useState } from 'react';
// import ReactDOM from 'react-dom';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import { createSubscription, getPackages } from '../../api/api';
// import { payments as SquarePayments } from '@square/web-sdk';
// import { useDispatch, useSelector } from 'react-redux';

// import PlansView from './PlansView';
// import CheckoutView from './CheckoutView';
// import { fetchMeThunk } from '../../redux/slices/authSlice';
// import { fetchUserStatistics } from '../../redux/slices/userStatisticsSlice';

// export default function UpgradeModal({ isOpen, onClose, isDarkMode }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { user } = useSelector((state) => state.auth);

//   const [plans, setPlans] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [payments, setPayments] = useState(null);
//   const [card, setCard] = useState(null);
//   const [cardLoading, setCardLoading] = useState(false);
//   const [processing, setProcessing] = useState(false);

//   const resetCheckout = async () => {
//     if (card) {
//       try {
//         await card.destroy();
//       } catch (err) {
//         console.error('Card destroy failed:', err);
//       } finally {
//         setCard(null);
//       }
//     }
//     setSelectedPlan(null);
//     setPayments(null);
//     setProcessing(false);
//     setCardLoading(false);
//   };

//   const resetAll = async () => {
//     await resetCheckout();
//     setPlans([]);
//   };

//   const handleClose = async () => {
//     await resetAll();
//     onClose();
//   };

//   useEffect(() => {
//     if (isOpen) {
//       setLoading(true);
//       getPackages()
//         .then((res) => {
//           if (res.success) setPlans(res.packages);
//         })
//         .catch((err) => console.error('getPackages error:', err.message))
//         .finally(() => setLoading(false));
//     }
//   }, [isOpen]);

//   // Init Square Payments SDK
//   useEffect(() => {
//     const init = async () => {
//       if (isOpen && selectedPlan && !payments) {
//         try {
//           const p = await SquarePayments(
//             process.env.REACT_APP_SQUARE_APP_ID,
//             process.env.REACT_APP_SQUARE_LOCATION_ID
//           );
//           setPayments(p);
//         } catch (err) {
//           console.error('Square init error:', err);
//           toast.error('Failed to initialize payments');
//         }
//       }
//     };
//     init();
//   }, [isOpen, selectedPlan, payments]);

//   // Mount card field
//   useEffect(() => {
//     const mountCard = async () => {
//       if (payments && selectedPlan && !card) {
//         try {
//           setCardLoading(true);
//           const cardInstance = await payments.card();
//           await cardInstance.attach('#card-container');
//           setCard(cardInstance);
//         } catch (err) {
//           console.error('Card attach error:', err);
//           toast.error('Failed to load card field');
//         } finally {
//           setCardLoading(false);
//         }
//       }
//     };
//     mountCard();
//   }, [payments, selectedPlan, card]);

//   // Cleanup when modal closes
//   useEffect(() => {
//     if (!isOpen) {
//       resetAll();
//     }
//   }, [isOpen]);

//   // Handle payment
//   const handlePayment = async () => {
//     if (!card || !selectedPlan) return;

//     setProcessing(true);

//     try {
//       const result = await card.tokenize();

//       if (result.status !== 'OK') {
//         return toast.error(
//           result?.errors?.[0]?.message || 'Card failed to tokenize'
//         );
//       }

//       console.log('result', result);

//       // Create subscription
//       const data = await createSubscription(selectedPlan.id, result.token);

//       if (data.success) {
//         toast.success(
//           'Payment successful. We’re setting up your subscription.',
//           {
//             duration: 4000,
//           }
//         );

//         try {
//           await dispatch(fetchUserStatistics(user?.id));
//           await dispatch(fetchMeThunk());
//         } catch (err) {
//           console.log('Failed to refresh user after subscription:', err);
//         }

//         await handleClose();
//         setTimeout(() => navigate('/app/settings'), 500);
//         return;
//       }

//       // API responded but with success=false
//       toast.error(data?.error || 'Subscription failed. Please try again.');
//     } catch (err) {
//       console.error('🔴 handlePayment error:', err);

//       toast.error(err.message || 'Unexpected server error');
//     } finally {
//       setProcessing(false);
//     }
//   };

//   if (!isOpen) return null;

//   return ReactDOM.createPortal(
//     <div
//       className="fixed inset-0 bg-black/60 z-50 overflow-y-auto"
//       onClick={handleClose}
//     >
//       <div className="flex min-h-screen items-center justify-center p-4">
//         <div
//           className={`rounded-lg shadow-xl w-full max-w-5xl mx-3 overflow-hidden relative min-h-[300px] flex flex-col
//     ${
//       isDarkMode
//         ? 'bg-gray-900 text-gray-100 border border-gray-800'
//         : 'bg-white text-gray-900'
//     }
//   `}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <button
//             onClick={handleClose}
//             className="absolute top-4 right-4 p-2 rounded-full
//     text-gray-500 hover:text-white
//     hover:bg-[#5A60D6] active:scale-95
//     shadow-sm hover:shadow-md
//     transition-all duration-200"
//             aria-label="Close modal"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={2}
//               stroke="currentColor"
//               className="w-5 h-5"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </button>

//           <div className="w-full flex-1 flex flex-col">
//             <div className="flex-1 overflow-y-auto">
//               {loading ? (
//                 <div className="flex justify-center items-center w-full h-full py-20">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand"></div>
//                 </div>
//               ) : !selectedPlan ? (
//                 <PlansView
//                   plans={plans}
//                   onSelect={setSelectedPlan}
//                   isDarkMode={isDarkMode}
//                 />
//               ) : (
//                 <CheckoutView
//                   plan={selectedPlan}
//                   processing={processing}
//                   onBack={resetCheckout}
//                   onConfirm={handlePayment}
//                   cardLoading={cardLoading}
//                   isDarkMode={isDarkMode}
//                 />
//               )}
//             </div>

//             <div className="px-6 pb-6 pt-4 text-center text-xs text-gray-500 border-t mt-6">
//               Need more?{' '}
//               <a
//                 href="https://www.ulegal.ai/contact/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-brand hover:underline"
//               >
//                 Contact us
//               </a>{' '}
//               for API Integration or custom enterprise solutions. <br />
//               Or cancel anytime, no questions asked.
//               <div className="mt-4 flex justify-center space-x-6 text-[11px] text-gray-400">
//                 <a
//                   href="https://www.ulegal.ai/terms-conditions/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="underline hover:text-gray-300"
//                 >
//                   Terms of Service
//                 </a>
//                 <a
//                   href="https://www.ulegal.ai/privacy-policy/"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="underline hover:text-gray-300"
//                 >
//                   Privacy Policy
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// }
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import toast from 'react-hot-toast';

import { getPackages, createCheckoutSession } from '../../api/api';
import PlansView from './PlansView';

export default function UpgradeModal({ isOpen, onClose, isDarkMode }) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autoRedirectPlanId, setAutoRedirectPlanId] = useState(null);

  // 1️⃣ Load plans when modal opens
  useEffect(() => {
    if (!isOpen) return;

    setLoading(true);
    getPackages()
      .then((res) => {
        if (res?.success) setPlans(res.packages || []);
        else toast.error('Failed to load plans');
      })
      .catch(() => toast.error('Failed to load plans'))
      .finally(() => setLoading(false));
  }, [isOpen]);

  // 2️⃣ AUTO STRIPE REDIRECT FROM sessionStorage (upgrade_intent)
  // useEffect(() => {
  //   if (!isOpen) return;
  //   if (!plans.length) return;

  //   const intent = sessionStorage.getItem('upgrade_intent');
  //   if (!intent) return;

  //   // prevent infinite loop
  //   if (sessionStorage.getItem('auto_checkout_done')) return;

  //   const plan = plans.find((p) => String(p.price) === String(intent));

  //   if (!plan) {
  //     toast.error(
  //       'We couldn’t find that plan. Please select one of the available options.',
  //     );
  //     sessionStorage.removeItem('upgrade_intent');
  //     return;
  //   }
  //   setAutoRedirectPlanId(plan.id); // ✅ THIS LINE

  //   sessionStorage.setItem('auto_checkout_done', '1');
  //   sessionStorage.removeItem('upgrade_intent');

  //   (async () => {
  //     try {
  //       const res = await createCheckoutSession(plan.id);

  //       if (!res?.checkout_url) {
  //         throw new Error('Checkout URL missing');
  //       }

  //       // 🔥 HARD redirect to Stripe
  //       window.location.href = res.checkout_url;
  //     } catch (err) {
  //       sessionStorage.removeItem('auto_checkout_done');
  //       toast.error(err?.message || 'Unable to start checkout');
  //     }
  //   })();
  // }, [isOpen, plans]);
  useEffect(() => {
    if (!isOpen) return;
    if (!plans.length) return;

    const intent = sessionStorage.getItem('upgrade_intent');
    if (!intent) return;

    if (sessionStorage.getItem('auto_checkout_done')) return;

    // ✅ 1. If "all" → just show plans, no redirect, no error
    if (intent === 'all') {
      sessionStorage.removeItem('upgrade_intent');
      return;
    }

    // ✅ 2. Try to match price
    const plan = plans.find((p) => String(p.price) === String(intent));

    // ❌ 3. If invalid price → show error
    if (!plan) {
      toast.error(
        'We couldn’t find that plan. Please select one of the available options.',
      );
      sessionStorage.removeItem('upgrade_intent');
      return;
    }

    // ✅ 4. Valid plan → proceed to checkout
    setAutoRedirectPlanId(plan.id);

    sessionStorage.setItem('auto_checkout_done', '1');
    sessionStorage.removeItem('upgrade_intent');

    (async () => {
      try {
        const res = await createCheckoutSession(plan.id);

        if (!res?.checkout_url) {
          throw new Error('Checkout URL missing');
        }

        window.location.href = res.checkout_url;
      } catch (err) {
        sessionStorage.removeItem('auto_checkout_done');
        toast.error(err?.message || 'Unable to start checkout');
      }
    })();
  }, [isOpen, plans]);

  // 3️⃣ Cleanup when modal closes
  useEffect(() => {
    if (!isOpen) {
      sessionStorage.removeItem('auto_checkout_done');
      setAutoRedirectPlanId(null); // ✅ add this
      setPlans([]);
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-black/60 z-50 overflow-y-auto"
      onClick={onClose}
    >
      <div className="flex min-h-screen items-center justify-center p-4">
        <div
          className={`rounded-lg shadow-xl w-full max-w-5xl mx-3 overflow-hidden relative min-h-[300px] flex flex-col
            ${
              isDarkMode
                ? 'bg-gray-900 text-gray-100 border border-gray-800'
                : 'bg-white text-gray-900'
            }
          `}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-full 
              text-gray-500 hover:text-white 
              hover:bg-[#5A60D6] active:scale-95 
              shadow-sm hover:shadow-md 
              transition-all duration-200"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {/* Content */}
          <div className="w-full flex-1 flex flex-col">
            <div className="flex-1 overflow-y-auto">
              {loading ? (
                <div className="flex justify-center items-center w-full h-full py-20">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand" />
                </div>
              ) : (
                <PlansView
                  plans={plans}
                  isDarkMode={isDarkMode}
                  autoRedirectPlanId={autoRedirectPlanId}
                />
              )}
            </div>

            {/* Footer (preserved) */}
            <div className="px-6 pb-6 pt-4 text-center text-xs text-gray-500 border-t mt-6">
              Need more?{' '}
              <a
                href="https://www.ulegal.ai/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand hover:underline"
              >
                Contact us
              </a>{' '}
              for API Integration or custom enterprise solutions. <br />
              Or cancel anytime, no questions asked.
              <div className="mt-4 flex justify-center space-x-6 text-[11px] text-gray-400">
                <a
                  href="https://www.ulegal.ai/terms-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-gray-300"
                >
                  Terms of Service
                </a>
                <a
                  href="https://www.ulegal.ai/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-gray-300"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
